import type { ReportRow } from '@/core/models/reports.models';

// D05 (as Capium 3.0): which accounts a client may file does not depend on its size. 3.0 lists every saved
// Abridged/Filleted report for submission, whatever the company size (Accounts/Tasks/SubmitHistory.aspx.cs:110;
// Reports/Default.aspx:116). The UI no longer hides Abridged/Filleted for a medium or large company; Full stays
// submittable here because the filing flow supports it. Whether a report is eligible is the API's check at Submit.

/** How a report is named on the submission filed from it; #169 matches on the "Accounts {refNo} " prefix. */
export function reportLabel(row: ReportRow): string {
  return `${row.refNo} - ${row.fromDate} to ${row.toDate} - ${row.type}${row.description ? ' - ' + row.description : ''}`;
}

/**
 * #168/#171: whether a submission was started for this report. A submission belongs to an accounting period, not a
 * report, so the report is known only by the "Accounts {refNo} " name it was created with (the prefix #169 deletes by).
 */
export function isSubmissionFor(submission: { description?: string | null }, refNo: string): boolean {
  return (submission.description ?? '').startsWith(`Accounts ${refNo} `);
}

/** The submission description used when a submission is created for a report. */
export function submissionDescription(row: ReportRow): string {
  return `Accounts ${reportLabel(row)}`;
}
